<script context="module">
  import Search from "./Search.svelte";
  import Modal from "../Components/Modal.svelte";
</script>

<script>
  export let success;

  let open = true;
</script>

<Modal bind:open dialogClasses="modal-dialog-centered modal-lg text-center">
  <div
    class="modal-body d-flex align-items-center shadow-lg rounded-4"
    class:bg-danger={!success}
    class:bg-success={success}
  >
    <div
      class:text-bg-danger={!success}
      class:text-bg-success={success}
      class="fs-6 w-100"
    >
      {#if success}
        You have been unsubscribed from assessment reminders.
      {:else}
        Unable to complete your unsubscription request with the provided link.
      {/if}
    </div>
    <button
      type="button"
      class="btn-close float-end"
      on:click={() => (open = false)}
    ></button>
  </div>
</Modal>

<Search />
